module.exports = __webpack_public_path__ + "img/home-contact.2c05ff8f.png";